
<template>
<div>
  <h3>Towing Tiers</h3>
  <chc-checkbox v-on:input="checkboxChanged" v-model="data.towing_fees_included_in_sale_price" label="Towing Fees Included in Sale Price"></chc-checkbox>
  <transition name="slide-fade">
    <div v-if="!data.towing_fees_included_in_sale_price">
      <div class="towing-tier field" v-for="(tier, index) in data.towing_tiers" :key="index">
        <chc-input v-model="tier.bottom" label="# of Miles"></chc-input>
        <span> to </span>
        <chc-input v-model="tier.top" label="# of Miles"></chc-input>
        <span> Miles </span>
        <chc-input v-model="tier.fee" label="Fee" format="currency"></chc-input>
        <span> <a @click="removeTowingTier(index)"> Delete </a> </span>
      </div>
      <div class="add-tier field">
        <a v-on:click="addTowingTier">+ Add Another Tier</a>
      </div>
    </div>
  </transition>
</div>
</template>

<script>

export default {
  name: 'TowingCompanyTiers',
  props: ['data'],
  methods: {
    addTowingTier () {
      this.data.towing_tiers.push({
        bottom: null,
        top: null,
        fee: null
      })
    },
    removeTowingTier (index) {
      this.data.towing_tiers.splice(index, 1)
    },
    checkboxChanged () {
      if (this.data.towing_fees_included_in_sale_price) {
        this.data.towing_tiers = [
          {
            bottom: null,
            top: null,
            fee: null
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.towing-tier {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.towing-tier span {
    padding-left: 1em;
    padding-right: 1em;
}

.slide-fade-enter-active {
    transition: all .3s ease;
}
.slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/TowingCompany/TowingCompanyTiers.vue